import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonIconsComponent } from './common-icons/common-icons.component';
import { SocialShareIconsComponent } from './social-share-icons/social-share-icons.component';
import { MenuIconsComponent } from './menu-icons/menu-icons.component';



@NgModule({
  declarations: [
    CommonIconsComponent,
    SocialShareIconsComponent,
    MenuIconsComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CommonIconsComponent,
    SocialShareIconsComponent,
    MenuIconsComponent
  ]
})
export class SharedIconsModule { }
